
export default {
  status(name = undefined) {
    const statuses = {
      formed: { name: 'formed', title: 'Черновик', },
      approving: { name: 'approving', title: 'На проверке', },
      approved: { name: 'approved', title: 'Проверено', },
      correction: { name: 'correction', title: 'Корректируется', },
      corrected: { name: 'corrected', title: 'Скорректировано', },
      waiting: { name: 'waiting', title: 'Ожидание', },
      waitingFinish: { name: 'waitingFinish', title: 'Ожидание', },
      done: { name: 'done', title: 'Завершено', },
    }
    return statuses[name]?.title
  },

  numberFormat(number) {
    if (!Number(number)) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    }
    if (number) {
      return (Math.round(number * 100).toFixed(2)/100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    }
    return 0
  },
}
